<template>
  <button
    type="button"
    :aria-expanded="props.open"
    :aria-label="ariaButtonLabel"
    :class="[
      { 'border-neutral-200 bg-white' : !props.open && !props.active },
      { 'border-petrol-500 bg-white' : props.open && !props.active },
      { 'border-petrol-500 bg-petrol-50' : props.active },
      'rounded-full border inline-block cursor-pointer leading-5 text-sm max-w-full min-w-0 overflow-hidden'
    ]"
  >
    <span class="flex items-center align-middle min-w-0 max-w-full">
      <span class="py-3 pl-4 pr-1.5 truncate min-w-0">
        <slot />
      </span>
      <span class="pr-4 shrink-0">
        <UiIcon
          src="/svg/icons/arrow-super-thin.svg"
          width="11"
          height="6"
          :class="[
            { '-rotate-180 mt-[-3px]' : props.open },
            { 'mt-[-1px]' : !props.open },
            'stroke-neutral-800 inline-block'
          ]"
        />
      </span>
    </span>
  </button>
</template>

<script setup lang="ts">
const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  ariaButtonLabel: {
    type: [String, Boolean, Number, Array],
    default: false
  },
  active: {
    type: Boolean,
    default: false
  }
})
</script>

<style>
:root {
  --popper-theme-background-color: #FFFFFF;
  --popper-theme-background-color-hover: #FFFFFF;
  --popper-theme-text-color: #000000;
  --popper-theme-border-color: rgb(228 228 228 / 1);
  --popper-theme-border-width: 1px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 0.5rem;
  --popper-theme-padding: 0;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>
